export let AdditionalSeatsSkuId;
(function (AdditionalSeatsSkuId) {
  AdditionalSeatsSkuId[AdditionalSeatsSkuId["PROD"] = 824255] = "PROD";
  AdditionalSeatsSkuId[AdditionalSeatsSkuId["QA"] = 130401] = "QA";
})(AdditionalSeatsSkuId || (AdditionalSeatsSkuId = {}));